export default __webpack_public_path__ + "static/media/project_coming.5767d85b.jpg";